import { styled } from "styled-components";

export const AuthorInfoContainer = styled.div`
  // 닉네임 + 날짜
  max-width: 450px;
  margin-top: 10px;
`;
